(() => {
  'use strict';
  if (window.__AQUAPHORIA_AQUARIUM_LIVE_V4__) return;
  window.__AQUAPHORIA_AQUARIUM_LIVE_V4__ = true;

  const d = document;
  const body = d.body;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const atrium = d.querySelector('[data-aq-v4-atrium]');
  if (!atrium) return;

  const waterButton = atrium.querySelector('[data-aq-v4-water-toggle]');
  const dayButton = atrium.querySelector('[data-aq-v4-day-toggle]');
  const soundButton = atrium.querySelector('[data-aq-v4-sound-toggle]');
  const loader = atrium.querySelector('[data-aq-v4-aquarium-loader]');

  function setPressed(button, value) {
    if (!button) return;
    button.classList.toggle('is-active', value);
    button.setAttribute('aria-pressed', value ? 'true' : 'false');
  }

  function finishLoader() {
    if (!loader) return;
    window.setTimeout(() => loader.classList.add('is-done'), reduced.matches ? 0 : 520);
  }
  let waterOn = !reduced.matches;
  body.classList.toggle('aq-v4-aquarium-paused', !waterOn);
  setPressed(waterButton, waterOn);
  waterButton?.addEventListener('click', () => {
    waterOn = !waterOn;
    body.classList.toggle('aq-v4-aquarium-paused', !waterOn);
    setPressed(waterButton, waterOn);
  });

  let dayMode = false;
  dayButton?.addEventListener('click', () => {
    dayMode = !dayMode;
    body.classList.toggle('aq-v4-aquarium-day', dayMode);
    setPressed(dayButton, dayMode);
    const text = dayButton.lastChild;
    if (text && text.nodeType === Node.TEXT_NODE) text.nodeValue = dayMode ? ' Day Mode' : ' Night Mode';
  });

  let audioContext = null;
  let noiseSource = null;
  let noiseGain = null;
  let soundOn = false;
  function stopAmbient() {
    try { noiseSource?.stop(); } catch (_) {}
    noiseSource = null;
    if (noiseGain) noiseGain.gain.setTargetAtTime(0, audioContext?.currentTime || 0, .08);
    soundOn = false;
    setPressed(soundButton, false);
  }

  async function startAmbient() {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    audioContext ||= new AC();
    if (audioContext.state === 'suspended') await audioContext.resume();

    const seconds = 2;
    const buffer = audioContext.createBuffer(1, audioContext.sampleRate * seconds, audioContext.sampleRate);
    const data = buffer.getChannelData(0);
    let last = 0;
    for (let i = 0; i < data.length; i += 1) {
      const white = Math.random() * 2 - 1;
      last = (last + .02 * white) / 1.02;
      data[i] = last * 2.7;
    }
    noiseSource = audioContext.createBufferSource();
    noiseSource.buffer = buffer;
    noiseSource.loop = true;
    const filter = audioContext.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.value = 520;
    filter.Q.value = .3;
    noiseGain = audioContext.createGain();
    noiseGain.gain.value = .018;
    noiseSource.connect(filter).connect(noiseGain).connect(audioContext.destination);
    noiseSource.start();
    soundOn = true;
    setPressed(soundButton, true);
  }

  soundButton?.addEventListener('click', async () => {
    if (soundOn) stopAmbient();
    else {
      try { await startAmbient(); }
      catch (_) { stopAmbient(); }
    }
  });

  addEventListener('pagehide', stopAmbient, { once: true });
  finishLoader();
})();
